import type { FeatureManifest } from '@/platform/navigation/featureManifest'

const group = { id: 'inventory', label: 'Quản lý sản xuất' }
export const inventoryItemsManifest: FeatureManifest = {
  id: 'inventory-items', path: 'inventory/items', navPath: '/inventory/items', label: 'Nguyên liệu & công cụ',
  requiredPermissions: ['inventory'], navigationGroup: group, load: () => import('./items/entry'),
}
export const inventorySuppliersManifest: FeatureManifest = {
  id: 'inventory-suppliers', path: 'inventory/suppliers', navPath: '/inventory/suppliers', label: 'Nhà cung cấp',
  requiredPermissions: ['inventory'], navigationGroup: group, load: () => import('./suppliers/entry'),
}
export const inventoryPurchasesManifest: FeatureManifest = {
  id: 'inventory-purchases', path: 'inventory/purchases', navPath: '/inventory/purchases', label: 'Lịch sử nhập hàng',
  requiredPermissions: ['inventory'], navigationGroup: group, load: () => import('./purchases/entry'),
}
export const productStockManifest: FeatureManifest = {
  id: 'product-stock', path: 'inventory/product-stock', navPath: '/inventory/product-stock', label: 'Tồn kho sản phẩm',
  requiredPermissions: ['inventory'], navigationGroup: group, load: () => import('./product-stock/entry'),
}
